module.exports = "/static/Images/en/Nine.png";